import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'

import * as color from '../../color'

/**
 * Basic button
 *
 * **Inputs**
 *
 * - {@link AtnDsButtonComponent.disabled|disabled}?
 * - {@link AtnDsButtonComponent.style|style}?
 * - {@link AtnDsButtonComponent.isIconRaw|isIcon}?
 *
 * **Outputs**
 * - {@link AtnDsButtonComponent.click|click}
 *
 * @example
 * ```html
 * <!-- Basic button -->
 * <atn-ds-button
 * [disabled]="true"
 * [type]="styleEnum.primary"
 * [isIcon]="true"
 * (click)="clickHandler($event)"
 * >Button text</atn-ds-button>
 *
 * <!-- Button with icon -->
 * <atn-ds-button
 * [disabled]="true"
 * [type]="styleEnum.primary"
 * [isIcon]="true"
 * (click)="clickHandler($event)"
 * ><i class="atn-icon atn-trash atn-red"></i></atn-ds-button>
 * ```
 */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  imports: [ngCommon.NgClass],
  selector: 'atn-ds-button',
  standalone: true,
  styleUrls: ['./button.component.scss'],
  templateUrl: './button.component.html',
})
export class AtnDsButtonComponent {
  public readonly styleEnum = color.Legacy.PredefinedStyle

  /**
   * Indicates whether button is disabled or not
   */
  public readonly disabledSg = ngCore.input<boolean | undefined>(false, {
    alias: 'disabled',
  })

  /**
   * Indicates whether the button is in a loading state
   */
  public readonly loadingSg = ngCore.input<boolean | undefined>(false, {
    alias: 'loading',
  })

  /**
   * Type of button check {@link  color.Legacy.PredefinedStyle|Style}
   *
   * default {@link color.Legacy.PredefinedStyle.Primary|Legacy.PredefinedStyle.Primary}
   */
  // NOTE: this cannot be 'style' as that would shadow the built-in CSS style
  // input
  public readonly styleSg = ngCore.input<
    `${color.Legacy.PredefinedStyle}` | undefined
  >(color.Legacy.PredefinedStyle.Primary, {
    alias: 'type',
  })

  /**
   * Indicates whether button is icon, if true, removes default padding
   */
  public readonly isIconSg = ngCore.input<boolean | undefined>(false, {
    alias: 'isIcon',
  })

  /**
   * Click output
   */
  public readonly click = ngCore.output()

  /** Handles button click event. */
  public clickHandler($event: Event): void {
    $event.stopPropagation()
    if (!this.disabledSg() && !this.loadingSg()) {
      this.click.emit()
    }
  }
}
